export const REMOVABLE_NAMESPACE_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/
export const SCHEMA_NAME_PATTERN = /^[a-z][a-zA-Z0-9-]*$/
export const NAMESPACE_PATTERN = /^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/
export const MODULE_SPECIFIER_PATTERN =
  /(\bfrom\s*|\bimport\s*|\brequire\s*\(\s*|\bimport\s*\(\s*)(['"])([^'"\n]+)\2/g
export const EXTERNAL_PACKAGE_PATTERN =
  /^(?:@[a-z0-9-~][a-z0-9-._~]*\/)?[a-z0-9-~][a-z0-9-._~]*(?:\/[^'"]*)?$/
export const DEV_PORT_FLAG_PATTERN = /(?:^|\s)(?:--port(?:=|\s+)|-p(?:=|\s+)?)(\d+)(?=\s|$)/
export const DEV_PORT_ENV_PATTERN = /(?:^|\s)PORT=(\d+)(?=\s|$)/
export const LOCAL_PROTOCOL_PATTERN = /^(workspace|link|file|portal):/
export const CONFIG_IMPORT_PATTERN =
  /^import\s+\{[^}]*\bdefineConfig\b[^}]*\}\s+from\s+['"]betterstart-cli['"];?[^\S\n]*$/m
export const CONFIG_OBJECT_PATTERNS = [
  /\b(?:const|let|var)\s+\w+\s*:\s*NextConfig\s*=\s*\{/g,
  /\b(?:const|let|var)\s+nextConfig\s*=\s*\{/g,
  /\b(?:const|let|var)\s+\w+\s*:\s*NextConfig\s*=\s*(?:[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*)*\(\s*)+\{/g,
  /\b(?:const|let|var)\s+nextConfig\s*=\s*(?:[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*)*\(\s*)+\{/g,
  /export\s+default\s+\{/g,
  /export\s+default\s+(?:[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*)*\(\s*)+\{/g,
  /module\.exports\s*=\s*\{/g,
  /module\.exports\s*=\s*(?:[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*)*\(\s*)+\{/g
]
/**
 * On accounts without the Neon integration installed, the piped (non-TTY) `integration add` opens
 * the accept-terms page in a browser and polls until the user accepts, printing the URL in a
 * "Visit this URL if the browser does not open" line — the only signal that it is waiting.
 */
export const ACCEPT_TERMS_URL_PATTERN =
  /https:\/\/vercel\.com\/\S+\/integrations\/accept-terms\/\S+/i
/** Printed by the Vercel CLI once its accept-terms polling succeeds. */
export const TERMS_ACCEPTED_PATTERN = /terms accepted/i
